export const appName = 'salesman-app';
